export const BLACK = 'rgba(0,0,0,1)';
export const BLACK_WITH_OPACITY = 'rgba(0,0,0,0.5)';
export const WHITE = 'rgba(255,255,255,1)';
export const BLUE = 'rgba(5,74,151,1)';
export const RED = 'rgba(208,38,53,1)';
export const GREEN = 'rgba(17,143,72,1)';
export const LIGHT_GRAY = 'rgba(242,242,242,1)';
export const BROWN = 'rgba(51,57,70,1)';
export const LIGHT_BROWN = 'rgba(207, 207, 207,1)';
